import { BlockType } from '../../types/index.js';
import { AddToCalendarButtonBlock as Component } from './Block.js';
export const RegisteredAddToCalendarButtonBlock = (_intl) => ({
    recommendedName: 'AddToCalendarButton',
    Component,
    config: { type: BlockType.BuildingBlock },
});
//# sourceMappingURL=registered.js.map